import { MobileReservationActionTypes, MobileReservationsActionUnion } from './mobilereservation.actions';
import {
  adapter,
  initialState,
  MobileReservationState,
  selectMobileReservationIdFrom,
} from './mobilereservation.state';

export function mobileReservationReducer(
  state: MobileReservationState = initialState,
  action: MobileReservationsActionUnion
): MobileReservationState {
  switch (action.type) {
    case MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATIONS_LOADED:
      return adapter.upsertMany(action.payload.mobileReservations, state);
    case MobileReservationActionTypes.MOBILE_RESERVATION_SIGNALR_STATE_CHANGED:
      return adapter.upsertOne(action.payload.mobileReservation, state);
    case MobileReservationActionTypes.MOBILE_RESERVATION_API_MOBILE_RESERVATION_DELETED:
      return adapter.removeOne(selectMobileReservationIdFrom(action.payload.mobileReservation), state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectMobileReservationIds = selectIds;

export const selectMobileReservationEntities = selectEntities;

export const selectAllMobileReservations = selectAll;
